import { render, staticRenderFns } from "./MembersOnlyEdit.vue?vue&type=template&id=35aa86ea"
import script from "./MembersOnlyEdit.vue?vue&type=script&lang=ts"
export * from "./MembersOnlyEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports